import React from 'react';
import { DialogActions, Button, Divider } from '@mui/material';

import { MatterSearch } from '~/src/entities/clioMatters/components/MatterSearch';
import { ClioMatter } from '~/src/services/api/clioService';
import { ImportHeader } from '../ImportHeader';

type MatterSearchContentProps = {
  setSelectedClioMatter: (value: ClioMatter) => void;
  onClose: () => void;
};

const MatterSearchContent = ({
  setSelectedClioMatter,
  onClose,
}: MatterSearchContentProps) => {
  return (
    <>
      <ImportHeader onClose={onClose} title="Select a matter to import" />
      <Divider />
      <MatterSearch onSelect={setSelectedClioMatter} />
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </>
  );
};

export default MatterSearchContent;
